import React from "react";
import { useAdminApi } from "../../AdminApiContext";

const ServiceList = ({ onEdit }) => {
  const { services, loading, error, deleteService } = useAdminApi();

  if (loading) return <p>Загрузка сервисов…</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;


  const handleDelete = async (id, name) => {
    const confirmed = window.confirm(`Удалить сервис "${name}"?`);
    if (confirmed) {
      await deleteService(id);
    }
  };

  return (
    <>
      <h2>Сервисы</h2>
      {services.length === 0 ? (
        "Нет сервисов"
      ) : (
        <table border="1" cellPadding="6">
          <thead>
            <tr>
              <th>ID</th>
              <th>Имя</th>
              <th>Tech-name</th>
              <th>Цена/день</th>
              <th>Цена/мес</th>
              <th>Описание</th>
              <th>Значение</th>
              <th>видно в прайсе</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {services.map((s) => (
              <tr key={s.id}>
                <td>{s.id}</td>
                <td>{s.name}</td>
                <td>{s.technical_name}</td>
                <td>{s.daily_price}</td>
                <td>{s.month_price}</td>
                <td style={{ maxWidth: 300, whiteSpace: "pre-wrap" }}>{s.description}</td>
                <td>{s.value}</td>
                <td>{s.show_in_price ? "Да" : "—"}</td>
                <td>
                  <button onClick={() => onEdit(s)}>✏️</button>
                  <button
                    onClick={() => handleDelete(s.id, s.name)}
                    style={{ color: "red" }}
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default ServiceList;
